import createEndpoint, { createTanstackEndpoint } from "../utils/create-endpoint"
import { endpoints } from "./endpoints"

// Unified endpoint for getting all forms (inspection, issue, incident)
// Use form_type query parameter to filter by type
const endpoint = endpoints.forms.list

export default createEndpoint(endpoint, "GET")

export const getFormsTanstack = createTanstackEndpoint(endpoint, "GET")
